










import filters from "@/filters.coffee"

export default {
    "name": 'EstablishmentLogo',
    "props": {
        "establishment": Object
        "rounded": {
            "type": Boolean,
            "default": false
        }
    }
    "data": ()->
        return {
        }
    "computed": {
        "logo_style": ()->
            ret = ''
            if this.establishment.logo? and this.establishment.logo != ""
                ret = this.establishment.logo
            if this.rounded == true
                border_radius = "50%"
            else
                border_radius = "0%"
            return {
                "background-image": filters.filters.as_css_background_string(ret)
                "border-radius": border_radius
            }
    }
    "methods": {}
    "mounted": ()->
        return 
    "beforeDestroy": ()->
        return 
            

}
